import { createSlice } from "@reduxjs/toolkit"

const productSlice = createSlice({
    name: "product",
    initialState: {
        products: [],
        isFetching: false,
        error: null
    },
    reducers: {
        productStart: (state) => {
            state.isFetching = true
        },
        productFailure: (state, action) => {
            state.isFetching = false
            state.error = action.payload
        },
        getProductsSuccess: (state, action) => {
            state.isFetching = false
            state.error = null
            state.products = action.payload
        },
        deleteProductSuccess: (state, action) => {
            state.isFetching = false
            state.error = null
            state.products.splice(
                state.products.findIndex((item) => item._id === action.payload),
                1
            )
        },
        updateProductSuccess: (state, action) => {
            state.isFetching = false
            state.error = null
            state.products[state.products.findIndex((item) => item._id === action.payload.id)] = action.payload.product
        },
        createProductSuccess: (state, action) => {
            state.isFetching = false
            state.error = null
            state.products.push(action.payload)
        }
    }
})

export const {
    productStart,
    productFailure,
    getProductsSuccess,
    deleteProductSuccess,
    updateProductSuccess,
    createProductSuccess } = productSlice.actions
export default productSlice.reducer
